"use client"

import { Provider } from "react-redux"
import { setupStore } from "./store"
import { useRef } from "react"

export default function ReduxProvider({ children, initialData }) {
  const storeRef = useRef();

  if (!storeRef.current) {
    const preloadedState = initialData ? {
      seo: {
        seoData: initialData.seoData || null,
        loading: false,
        error: null
      },
      organization: {
        headerData: initialData.organization?.headerData || null,
        featuresData: initialData.organization?.featuresData || null,
        loading: false,
        error: null
      }
    } : undefined;

    storeRef.current = setupStore(preloadedState);
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}